import { ValidationGroup } from "devextreme-react/validation-group";
import { RequiredRule, StringLengthRule, Validator } from "devextreme-react/validator";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useContext, useState } from "react";
import { POInvoiceProduct } from "../types/POInvoiceProduct";
import { Field } from "../../../../layouts";
import TextBox from "devextreme-react/text-box";
import { POInvoiceContext } from "../context/POInvoiceContext";
import NumberBox from "devextreme-react/number-box";
import { useAuth } from "../../../../contexts/auth";
import { CompanyTypes } from "../../../../types/enums";

export default function NewInvoiceProductPopup(props: {
	visible: boolean,
	onPopupHidden: (result?: POInvoiceProduct) => void
}) {

	const { invoice } = useContext(POInvoiceContext);

	const { user } = useAuth();
	const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;

	var [invoiceProduct, setInvoiceProduct] = useState<POInvoiceProduct>({
		selected: false,
		poInvProductID: -invoice.details.products.length - 1,
		itemDescription: "",
		sku: "",
		uom: "",
		unitPrice: 0
	});

	return (
		<ValidationGroup>
			<Popup
				title="Add Invoice Line"
				visible={props.visible}
				hideOnOutsideClick={false}
				width={600}
				height={400}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: function () {
							props.onPopupHidden();
						}
					}}
					widget="dxButton"
					location="after"
				/>
				<div>
					<Field label="SKU">
						<TextBox
							value={invoiceProduct?.sku}
							onValueChanged={(e) => {
								setInvoiceProduct({ ...invoiceProduct, sku: e.value });
							}}
							className="required"
						>
							<Validator validationGroup="invoiceProductValidationGroup">
								<RequiredRule />
								<StringLengthRule max={50} />
							</Validator>
						</TextBox>
					</Field>
					<Field label="Item Description">
						<TextBox
							value={invoiceProduct?.itemDescription}
							onValueChanged={(e) => {
								setInvoiceProduct({ ...invoiceProduct, itemDescription: e.value });
							}}
							className="required"
						>
							<Validator validationGroup="invoiceProductValidationGroup">
								<RequiredRule />
								<StringLengthRule max={500} />
							</Validator>
						</TextBox>
					</Field>
					<Field label="UOM" visible={!isServiceProvider}>
						<TextBox
							value={invoiceProduct?.uom}
							onValueChanged={(e) => {
								setInvoiceProduct({ ...invoiceProduct, uom: e.value });
							}}
							className="required"
						>
							<Validator validationGroup="invoiceProductValidationGroup">
								<RequiredRule />
								<StringLengthRule max={20} />
							</Validator>
						</TextBox>
					</Field>
					<Field label="Quantity">
						<NumberBox
							value={invoiceProduct?.quantity}
							onValueChanged={(e) => {
								setInvoiceProduct({ ...invoiceProduct, quantity: e.value });
							}}
							showSpinButtons={true}
							min={0}
							format="##0.###"
							className="required"
						>
							<Validator validationGroup="invoiceProductValidationGroup">
								<RequiredRule />
							</Validator>
						</NumberBox>
					</Field>
					<Field label="Unit Price">
						<NumberBox
							value={invoiceProduct?.unitPrice}
							onValueChanged={(e) => {
								setInvoiceProduct({ ...invoiceProduct, unitPrice: e.value });
							}}
							showSpinButtons={true}
							min={0}
							format="$#0.00"
							className="required"
						>
							<Validator validationGroup="invoiceProductValidationGroup">
								<RequiredRule />
							</Validator>
						</NumberBox>
					</Field>
				</div>

				<ToolbarItem
					options={{
						validationGroup: 'invoiceProductValidationGroup',
						text: 'OK',
						onClick: (e: any) => {
							let validation = e.validationGroup.validate();
							if (validation.isValid) {
								props.onPopupHidden(invoiceProduct);
							}
						}
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<ToolbarItem
					options={{
						text: 'Cancel',
						onClick: () => props.onPopupHidden()
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>

			</Popup>
		</ValidationGroup>
	)
}
